import { useTranslation } from 'react-i18next';
import SchoolLogo from './SchoolLogo';

export default function LoadingSpinner({ 
  size = 'large', 
  message = null, 
  className = '' 
}) {
  const { t } = useTranslation();
  
  const containerClasses = {
    small: 'min-h-[100px]',
    medium: 'min-h-[200px]',
    large: 'min-h-screen'
  };
  
  return (
    <div className={`flex items-center justify-center ${containerClasses[size]} ${className}`}>
      <div className="text-center">
        <div className={`mb-4 flex justify-center`}>
          <SchoolLogo size={size === 'small' ? 'small' : size === 'medium' ? 'medium' : 'large'} />
        </div>
        <div className="text-lg text-gray-600">
          {message || t('common.loading')}
        </div>
      </div>
    </div>
  );
}
